export default "__VITE_ASSET__DO$o6Wtt__"